module.exports = __webpack_public_path__ + "img/XIN.a54c4b72.svg";